import React from 'react'
import { noop } from 'lodash-es'
import Input from './input'

type CheckBoxProps = {
  id?: string | null
  name?: string | null
  className?: string | null
  onChange?: (data: { name?: string | null; value: any; checked: boolean }) => void
  checked?: boolean
  value?: any
  indeterminate?: boolean
  disabled?: boolean
}

type CheckboxInputChangeEvent = {
  name: string
  value: string // or more?
  checked: boolean
}

const CheckBox: React.FC<CheckBoxProps> = ({
  id = null,
  name = null,
  className = null,
  onChange = noop,
  checked = false,
  value = '',
  indeterminate = false,
  disabled = false,
}) => {
  const handleChange = (event: CheckboxInputChangeEvent) => {
    const { checked, value } = event
    onChange({ name, value, checked })
  }

  return (
    <Input
      id={id}
      name={name}
      className={className}
      indeterminate={indeterminate}
      type="checkbox"
      onChange={handleChange}
      checked={checked} // not appearing as checked in UI? Make sure you don't call preventDefault() in any parent node click handlers
      value={value}
      disabled={disabled}
    />
  )
}

export default CheckBox
